<template>
  <div class="scene-my-ranking">
    <div class="back-button" @click="onBack">
      <img src="/images/game/back.png" />
    </div>

    <div class="table-head">
      <div class="table-tip">排名页2分钟更新一次，请耐心等待哦！</div>

      <div class="table-th">排名</div>
      <div class="table-th">昵称</div>
      <div class="table-th">答题正确数</div>
      <div class="table-th">闯关数</div>
      <div class="table-th">第二关</div>
      <div class="table-th">第二关</div>
      <div class="table-th">第三关</div>
      <div class="table-th">第四关</div>
      <div class="table-th">第五关</div>
      <div class="table-th">第六关</div>
    </div>
    <ScrollableContainer class="table-body" :width="880" :height="500" @change="onChange">
      <div class="table-tr" v-for="(item, index) in rankingList" :key="index">
        <div class="here" v-if="item.userId == userId">
          <img src="/images/game/here.png" />
        </div>
        <div class="table-td rank">{{item.ranking}}</div>
        <div class="table-td">{{item.nickName}}</div>
        <div class="table-td">{{item.correctCount}}</div>
        <div class="table-td">{{item.checkpointCount}}</div>
        <div class="table-td">
          <img :src="`/images/game/${item.cp1Result}.png`" />
        </div>
        <div class="table-td">
          <img :src="`/images/game/${item.cp2Result}.png`" />
        </div>
        <div class="table-td">
          <img :src="`/images/game/${item.cp3Result}.png`" />
        </div>
        <div class="table-td">
          <img :src="`/images/game/${item.cp4Result}.png`" />
        </div>
        <div class="table-td">
          <img :src="`/images/game/${item.cp5Result}.png`" />
        </div>
        <div class="table-td">
          <img :src="`/images/game/${item.cp6Result}.png`" />
        </div>
      </div>
      <!-- <div class="scroll" :style="`top: ${y}px`" slot="scroll"></div> -->
    </ScrollableContainer>
  </div>
</template>

<script>
import ScrollableContainer from "../common/ScrollableContainer";

export default {
  name: "MyRankingScene",
  components: {
    ScrollableContainer
  },
  data() {
    return {
      y: 0,
      rankingList: []
    };
  },
  computed: {
    userId: function() {
      return this.$store.state.sys.sysUser.me.id;
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "game",
        className: "common",
        methodName: "getRankingList",
        params: {}
      });
      this.rankingList = response;
    },
    onChange(y) {
      this.y = -y;

      // console.log(this.y);
    },
    onBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    }
  }
};
</script>


<style lang="scss" scoped>
.scene-my-ranking {
  width: 1100px;
  height: 560px;
  position: relative;

  background: linear-gradient(
    180deg,
    rgba(96, 66, 11, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );

  .back-button {
    position: absolute;
    width: 80px;
    height: 40px;
    cursor: pointer;
    z-index: 100;

    img {
      width: 100%;
    }

    img:hover {
      box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
    }
  }

  .table-head {
    width: 800px;
    padding: 0 150px;
    height: 60px;

    background: #60420b;

    .table-tip {
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      color: #ccc;
    }

    opacity: 0.7;
    .table-th {
      display: inline-block;
      width: 80px;
      text-align: center;
      height: 30px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
    }
  }

  .table-body {
    width: 800px;
    height: 500px;
    padding: 0 150px;
    position: relative;

    .scroll {
      top: 0;
      right: 0;
      position: absolute;
      width: 5px;
      height: 100px;
      background: rgba(158, 114, 33, 1);
    }

    .table-tr {
      position: relative;

      .here {
        vertical-align: top;
        margin-top: 10px;
        position: absolute;
        left: -100px;

        text-align: center;

        img {
          position: absolute;
          // width: 72px;
          left: -20px;
          height: 30px;
        }

        span {
          font-family: "FZFMJW";
          font-size: 14px;
          color: white;
        }
      }
      .table-td {
        // opacity: 0.7;
        vertical-align: top;
        display: inline-block;
        width: 80px;
        height: 45px;
        text-align: center;
        line-height: 45px;

        font-size: 16px;
        font-family: "DINMedium";
        font-weight: bold;
        color: white;

        img {
          margin-top: 5px;
          width: 32px;
          height: 36px;
        }
      }

      .rank {
        font-size: 24px;

        color: #e4c896;
      }
    }

    .table-tr:hover {
      background: #4e3f29;
    }
  }
}
</style>